'use strict';

var getParentIFrame = require('./getParentIFrame.js');
var iframePageInfo = require('./iframePageInfo.js');

const IFRAME_MIN_HEIGHT = 500;
let visibleDialogsCount = 0;
const restoreAutoResize = () => {
    if (visibleDialogsCount > 0) {
        visibleDialogsCount -= 1;
    }
    if (visibleDialogsCount === 0) {
        getParentIFrame.getParentIFrame()?.autoResize(true);
    }
};
const resizeToClientHeight = (data, iframeMinHeight = IFRAME_MIN_HEIGHT) => {
    const height = data?.clientHeight ?? iframeMinHeight;
    getParentIFrame.getParentIFrame()?.size(height.toString());
    getParentIFrame.getParentIFrame()?.autoResize(false);
};
const resizeModal = () => {
    visibleDialogsCount += 1;
    resizeToClientHeight(iframePageInfo.getIframePageInfo());
};
const restoreModalSize = () => {
    restoreAutoResize();
};

exports.resizeModal = resizeModal;
exports.restoreModalSize = restoreModalSize;
//# sourceMappingURL=iframeModalResize.js.map
